// extracted by mini-css-extract-plugin
module.exports = {"body":"ShowShopPopout_body__16BI7"};